<template>
    <notifications
        :group="group"
        position="bottom right"
        :close-on-click="true"
        class="warning-notifications ma-4"
        style="width: 90%; bottom: 55px; max-width: 400px; z-index: 10;"
    >
        <template slot="body" slot-scope="props">
            <v-card elevation="0" style="border-left: solid 4px #ff5252; position: relative;">
                <v-row>
                    <v-col cols="2" class="align-self-center ml-2">
                        <img :src="icons.info" width="40" />
                    </v-col>
                    <v-col class="align-self-center notification-text">
                        <p class="ma-0 pr-4">
                            {{ $t("pay.notification_text") }}
                        </p>
                        <a @click="addCreditCard()">{{ $t("pay.add") }}</a>
                    </v-col>
                </v-row>
            </v-card>
            <v-icon
                small
                style="position: absolute; top: 5px; right: 5px;"
                @click="closeNotification(props.close)"
            >
                mdi-close
            </v-icon>
        </template>
    </notifications>
</template>

<script>
import info from "@/assets/img/no-cc.png";

export default {
    name: "NoCreditCardNotification",
    props: ["group"],
    data() {
        return {
            icons: { info },
        };
    },
    methods: {
        addCreditCard() {
            this.$store.dispatch("OPEN_PAYMENTS_MODAL", true);
        },
        closeNotification(callback) {
            this.$store.dispatch("SET_OPENED_NOTIFICATIONS", {
                notification: "noCreditCard",
                isOpened: false,
            });
            callback();
        },
    },
};
</script>

<style scoped>
.notification-text p {
    color: #666666;
    font-size: 11px;
    line-height: 1.3;
}
.notification-text a {
    font-size: 11px;
    text-decoration: underline;
}
</style>
